import { get } from "lodash";

export const API_ERRORS = {
  CONFLICT: "CONFLICT",
  NOT_FOUND: "NOT_FOUND",
};

export const apiErrorCode = (error) =>
  get(error, "graphQLErrors.0.extensions.code", null);

export const apiErrorDetail = (error, key) =>
  get(error, ["graphQLErrors", 0, "extensions", key], null);
